<mdwg-header-layout>
</mdwg-header-layout>
<!-- <mdwg-nav-menu></mdwg-nav-menu> -->
<mdwg-messages-layout></mdwg-messages-layout>
<mdwg-main-layout></mdwg-main-layout>
<mdwg-adsense-layout></mdwg-adsense-layout>
<mdwg-footer-layout></mdwg-footer-layout>
<script>
    var scroll = new SmoothScroll('a[href*="#"]');
</script>
